export const emailTemplates = {
  welcome: (customerName: string = 'there') => ({
    subject: 'Welcome to Unity-Build Estimation!',
    plaintext: `Subject: Welcome to Unity-Build Estimation!

Hello ${customerName},

Thank you for your purchase! We're excited to have you join the Unity-Build Estimation community.

Your account has been successfully activated, and you can now access all the features of our platform.

Here's what you can do next:
1. Log in to your account at unitybuildestimation.com
2. Set up your first project
3. Start creating estimates and managing your construction projects

If you have any questions or need assistance, our support team is here to help. You can reach us at help@unitybuildestimation.com.

We look forward to helping you streamline your construction estimation process!

Best regards,
The Unity-Build Team`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="color: #333;">Welcome to Unity-Build Estimation!</h1>
        
        <p>Hello ${customerName},</p>
        
        <p>Thank you for your purchase! We're excited to have you join the Unity-Build Estimation community.</p>
        
        <p>Your account has been successfully activated, and you can now access all the features of our platform.</p>
        
        <h2 style="color: #333;">Here's what you can do next:</h2>
        <ol>
          <li>Log in to your account at <a href="https://unitybuildestimation.com" style="color: #0066cc; text-decoration: none;">unitybuildestimation.com</a></li>
          <li>Set up your first project</li>
          <li>Start creating estimates and managing your construction projects</li>
        </ol>
        
        <p>If you have any questions or need assistance, our support team is here to help. You can reach us at <a href="mailto:help@unitybuildestimation.com" style="color: #0066cc; text-decoration: none;">help@unitybuildestimation.com</a>.</p>
        
        <p>We look forward to helping you streamline your construction estimation process!</p>
        
        <p>Best regards,<br>
        The Unity-Build Team</p>
      </div>
    `,
  }),
  accountUpdate: (userName: string, fromEmail: string) => ({
    subject: 'Your Account Was Updated',
    plaintext: `Subject: Your Unity-Build Estimation Account Was Updated

Hello ${userName},

This is a confirmation that your Unity-Build Estimation account information was recently updated by ${userName}.

If you believe this account was compromised, please contact us at ${fromEmail} immediately.

To access your account:
1. Visit unitybuildestimation.com
2. Click the "Log In" button in the top left corner
3. Follow the log in instructions provided

If you encounter any difficulties logging in or have any questions, please do not hesitate to reach out to us at ${fromEmail}.

Thank you for continuing to trust Unity-Build Estimation for your estimation needs.

Best regards,  
The Unity-Build Team`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="color: #333;">Your Account Was Updated</h1>
        
        <p>Hello ${userName},</p>
        
        <p>This is a confirmation that your Unity-Build Estimation account information was recently updated by ${userName}.</p>
        
        <p>If you believe this account was compromised, please contact us at <a href="mailto:${fromEmail}" style="color: #0066cc; text-decoration: none;">${fromEmail}</a> immediately.</p>
        
        <h2 style="color: #333;">To access your account:</h2>
        <ol>
          <li>Visit <a href="https://unitybuildestimation.com" style="color: #0066cc; text-decoration: none;">unitybuildestimation.com</a></li>
          <li>Click the "Log In" button in the top left corner</li>
          <li>Follow the log in instructions provided</li>
        </ol>
        
        <p>If you encounter any difficulties logging in or have any questions, please do not hesitate to reach out to us at <a href="mailto:${fromEmail}" style="color: #0066cc; text-decoration: none;">${fromEmail}</a>.</p>
        
        <p>Thank you for continuing to trust Unity-Build Estimation for your estimation needs.</p>
        
        <p>Best regards,<br>
        The Unity-Build Team</p>
      </div>
    `,
  }),
  newUser: (userName: string, email: string, tempPassword: string, fromEmail: string) => ({
    subject: 'Welcome to Unity-Build Estimation!',
    plaintext: `Subject: Welcome to Unity-Build Estimation!

Hello ${userName},

We are excited to welcome you to Unity-Build Estimation. Your account has been successfully created, and you can now log in to start using our services.

Here are your login details:
- Email: ${email}
- Temporary Password: ${tempPassword}

To access your account:
1. Visit unitybuildestimation.com
2. Click the "Log In" button in the top left corner
3. Use the credentials provided above

Next Steps:
- Once logged in, we recommend updating your password for enhanced security. 
- You can update your password by clicking on the avatar in the top left corner, selecting "User Settings," and following the prompts.

If you experience any issues or have questions, feel free to contact us at ${fromEmail}.

Thank you for choosing Unity-Build Estimation! We look forward to supporting your estimation needs.

Best regards,  
The Unity-Build Team`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="color: #333;">Welcome to Unity-Build Estimation!</h1>
        
        <p>Hello ${userName},</p>
        
        <p>We are excited to welcome you to Unity-Build Estimation. Your account has been successfully created, and you can now log in to start using our services.</p>
        
        <h2 style="color: #333;">Here are your login details:</h2>
        <ul>
          <li>Email: ${email}</li>
          <li>Temporary Password: ${tempPassword}</li>
        </ul>
        
        <h2 style="color: #333;">To access your account:</h2>
        <ol>
          <li>Visit <a href="https://unitybuildestimation.com" style="color: #0066cc; text-decoration: none;">unitybuildestimation.com</a></li>
          <li>Click the "Log In" button in the top left corner</li>
          <li>Use the credentials provided above</li>
        </ol>
        
        <h2 style="color: #333;">Next Steps:</h2>
        <ul>
          <li>Once logged in, we recommend updating your password for enhanced security.</li>
          <li>You can update your password by clicking on the avatar in the top left corner, selecting "User Settings," and following the prompts.</li>
        </ul>
        
        <p>If you experience any issues or have questions, feel free to contact us at <a href="mailto:${fromEmail}" style="color: #0066cc; text-decoration: none;">${fromEmail}</a>.</p>
        
        <p>Thank you for choosing Unity-Build Estimation! We look forward to supporting your estimation needs.</p>
        
        <p>Best regards,<br>
        The Unity-Build Team</p>
      </div>
    `,
  }),
  verification: (userName: string = 'there', verificationCode: string) => ({
    subject: 'Verify Your Email for Unity-Build Estimation',
    plaintext: `Subject: Verify Your Email for Unity-Build Estimation

Hello ${userName},

Thank you for signing up with Unity-Build Estimation! To complete your account setup and continue to the payment process, please verify your email address.

Your verification code is: ${verificationCode}

Please enter this code on the verification page to continue your account creation process.

If you did not attempt to create an account with Unity-Build Estimation, please disregard this email.

Best regards,
The Unity-Build Team`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="color: #333;">Verify Your Email for Unity-Build Estimation</h1>
        
        <p>Hello ${userName},</p>
        
        <p>Thank you for signing up with Unity-Build Estimation! To complete your account setup and continue to the payment process, please verify your email address.</p>
        
        <div style="background-color: #f5f5f5; padding: 20px; text-align: center; margin: 20px 0; border-radius: 5px;">
          <h2 style="margin: 0; color: #333;">Your verification code is:</h2>
          <div style="font-size: 24px; font-weight: bold; letter-spacing: 2px; margin: 15px 0; color: #0066cc;">${verificationCode}</div>
        </div>
        
        <p>Please enter this code on the verification page to continue your account creation process.</p>
        
        <p>If you did not attempt to create an account with Unity-Build Estimation, please disregard this email.</p>
        
        <p>Best regards,<br>
        The Unity-Build Team</p>
      </div>
    `,
  }),
};
